jQuery(document).ready(function($) {

    // First check for immediate redirect if we're on confirmation page
    if (jQuery('.gform_confirmation_wrapper').length || window.location.href.indexOf('gform_confirmation') !== -1) {
        // console.log('Confirmation detected, attempting redirect...');
        // Get the stored URL from sessionStorage
        const redirectUrl = sessionStorage.getItem('quiz_winner_url');
        if (redirectUrl) {
            saveQuizData(redirectUrl);
            return; // Stop execution since we're redirecting
        }
    }

    if(jQuery('.personalities-quiz__question__answer').length > 0){
        // Store points for each personality
        const personalityPoints = {};

        // Track which questions have been answered
        const answeredQuestions = new Set();

        // Store the submit button from the form
        let submitButton = null;

        // Keep track of selected tiebreaker personality
        let selectedTiebreakerPersonality = null;

        // Track form submission to prevent resubmission when using back button
        // let formAlreadySubmitted = false;

        // Get all answer buttons
        const answerButtons = jQuery('.personalities-quiz__question__answer:not(.tiebreaker-answer):not(.quiz-form)');

        // Get the tiebreaker dialog
        const tiebreakerDialog = jQuery('.personalities-quiz__tie-braker');
        
        // Get the tiebreaker answer buttons
        const tiebreakerButtons = jQuery('.tiebreaker-answer');

        // Track if a tiebreaker is needed
        let tiebreakerNeeded = false;

        // Get the form
        const form = jQuery('.gform_wrapper form');

        //  console.log(form);

        // Create a message element for incomplete questions
        const incompleteMessage = jQuery('<div class="personalities-quiz__incomplete-message" style="display: none;">Please answer all the questions to see your personality.</div>');
        
        // Add message before the questions
        jQuery('.personalities-quiz__quiz .quiz-title').after(incompleteMessage);
        
        // Create custom submit button for incomplete answers
        const customSubmitBtn = jQuery('<button class="custom-submit-btn gform_button" style="display: none;">Show my personality</button>');
        
        // Function to check if all questions are answered
        function checkAllQuestionsAnswered() {
            const totalQuestions = jQuery('.personalities-quiz__question:not(.personalities-quiz__question--last)').length;
            const regularQuestionsComplete = answeredQuestions.size >= totalQuestions;
            
            // If a tiebreaker is needed, also check if it's been answered
            if (tiebreakerNeeded) {
                return regularQuestionsComplete && selectedTiebreakerPersonality !== null;
            }
            
            return regularQuestionsComplete;
        }
        
        // Function to update button visibility based on answers
        function updateSubmitButtonState() {
            if (checkAllQuestionsAnswered()) {
                // Show real submit button, hide custom button
                if (submitButton) jQuery(submitButton).show();
                customSubmitBtn.hide();
                incompleteMessage.hide();
            } else {
                // Hide real submit button, show custom button
                if (submitButton) jQuery(submitButton).hide();
                customSubmitBtn.show();
            }
        }

        // Initialize personalities
        answerButtons.each(function() {
            const personality = jQuery(this).data('personality');
            if (personality && !personalityPoints[personality]) {
                personalityPoints[personality] = 0;
            }
        });

        // Add click event to answer buttons
        answerButtons.on('click', function() {
            // Clear any previously stored URLs when answers change
            sessionStorage.removeItem('quiz_winner_url');
            sessionStorage.removeItem('quiz_winner_personality');
            
            // Get the personality for this answer
            const personality = jQuery(this).data('personality');

            // Get the question element
            const question = jQuery(this).closest('.personalities-quiz__question');
            const questionIndex = question.parent().children().index(question);

            // If this question has already been answered, subtract the point from the previous answer
            if (answeredQuestions.has(questionIndex)) {
                // Find the previously selected button in this question
                const previousSelectedButton = question.find('.personalities-quiz__question__answer.selected');
                if (previousSelectedButton.length) {
                    const prevPersonality = previousSelectedButton.data('personality');
                    if (prevPersonality) {
                        personalityPoints[prevPersonality]--;
                    }
                    previousSelectedButton.removeClass('selected');
                }
            }

            // Add point for the selected personality
            if (personality) {
                personalityPoints[personality]++;
            }

            // Mark this question as answered
            answeredQuestions.add(questionIndex);

            // Add selected class to this button
            jQuery(this).addClass('selected');
            // Remove selected class from sibling button
            jQuery(this).siblings('.personalities-quiz__question__answer').removeClass('selected');

            // console.log('Personality points:', personalityPoints);
            
            // Check if we have a tie and need tiebreaker
            const result = calculateWinnerWithoutSaving();
            tiebreakerNeeded = result.isTie;
            
            // Update submit button state after answering
            updateSubmitButtonState();
        });

        // Add click events to tiebreaker buttons
        tiebreakerButtons.on('click', function() {
            // Remove selected class from all tiebreaker buttons
            tiebreakerButtons.removeClass('selected');

            // Add selected class to this button
            jQuery(this).addClass('selected');

            // Store the selected personality
            selectedTiebreakerPersonality = jQuery(this).data('personality');
            
            // Close the dialog
            tiebreakerDialog[0].close();
            
            // Update tiebreaker status
            tiebreakerNeeded = false;
            
            // Store the URL immediately for tie-breaker case
            storePersonalityUrl(selectedTiebreakerPersonality);
            
            // Update submit button state after selecting tiebreaker
            updateSubmitButtonState();

            // Submit the form if all questions are answered and form hasn't been submitted already
            // if (checkAllQuestionsAnswered() && !formAlreadySubmitted) {
            //     formAlreadySubmitted = true;
            //     form[0].submit();
            // }
        });

        // Track the current price range value
        let currentPriceRange = '';

        // Function to get price range and format it for URL
        function getPriceRangeParam() {
            // Try multiple selectors to find price inputs
            let priceInputs = jQuery('input[name="input_7"]');
            
            // If not found, try other common selectors for radio inputs
            if (!priceInputs.length) {
                // console.log('Price input not found by name="input_7", trying alternatives...');
                // Try to find by field class (common in Gravity Forms)
                priceInputs = jQuery('.gfield.price-range input[type="radio"]');
                
                // If still not found, try any radio in the form
                if (!priceInputs.length) {
                    priceInputs = form.find('input[type="radio"]');
                    // console.log('Trying all radio inputs in form, found:', priceInputs.length);
                }
            }
            
            // console.log('Price inputs found:', priceInputs.length);
            
            let selectedPrice = '';
            
            // Log all price inputs and their values for debugging
            priceInputs.each(function(index) {
                // console.log(`Price input ${index}:`, this.value, 'Checked:', this.checked);
                if (this.checked) {
                    selectedPrice = this.value;
                    // console.log('Selected price found:', selectedPrice);
                }
            });
            
            // If still no selected price, check for other input types like select
            if (!selectedPrice) {
                const priceSelect = form.find('select.price-range, select[name*="price"]');
                if (priceSelect.length) {
                    selectedPrice = priceSelect.val();
                    // console.log('Found price from select element:', selectedPrice);
                }
            }
            
            // If we have a stored price from previous detection, use that as fallback
            if (!selectedPrice && currentPriceRange) {
                // console.log('Using previously stored price range:', currentPriceRange);
                return currentPriceRange;
            }
            
            // console.log('Final selected price before transformation:', selectedPrice);
            
            // Transform the price format to URL format
            if (selectedPrice) {
                let priceParam = '';
                
                if (selectedPrice.includes('Less than $100') || selectedPrice.includes('less than 100')) {
                    priceParam = 'less-than-100';
                } else if (selectedPrice.includes('$100 - $500') || selectedPrice.includes('100-500')) {
                    priceParam = '100-500';
                } else if (selectedPrice.includes('$500 - $1000') || selectedPrice.includes('500-1000')) {
                    priceParam = '500-1000';
                } else if (selectedPrice.includes('$1000+') || selectedPrice.includes('1000+')) {
                    priceParam = '1000';
                } else {
                    // Try to parse the value directly if it's a number
                    const numValue = parseInt(selectedPrice, 10);
                    if (!isNaN(numValue)) {
                        if (numValue < 100) {
                            priceParam = 'less-than-100';
                        } else if (numValue < 500) {
                            priceParam = '100-500';
                        } else if (numValue < 1000) {
                            priceParam = '500-1000';
                        } else {
                            priceParam = '1000';
                        }
                    }
                }
                
                // console.log('Transformed price to URL parameter:', priceParam);
                
                // Store the price range for future use
                if (priceParam) {
                    currentPriceRange = priceParam;
                }
                
                return priceParam;
            }
            
            // console.log('No price range detected');
            return '';
        }

        // Add change event listeners to price inputs to capture changes
        function setupPriceInputListeners() {
            // Find all possible price inputs
            const allPriceInputs = jQuery('input[type="radio"], select.price-range, select[name*="price"]');
            
            // Add change event listener to each
            allPriceInputs.on('change', function() {
                // console.log('Price input changed, recalculating price range');
                // Update the current price range
                currentPriceRange = getPriceRangeParam();
                // console.log('Updated current price range to:', currentPriceRange);
            });
            
            // console.log('Price input listeners set up on', allPriceInputs.length, 'elements');
        }

        // Run setup for price input listeners
        setupPriceInputListeners();
        
        // We should also listen for dynamic form changes that might add new inputs
        jQuery(document).on('gform_post_render', function() {
            // console.log('Form re-rendered, setting up price input listeners again');
            setupPriceInputListeners();
            
            // Also try to capture the price range immediately
            currentPriceRange = getPriceRangeParam();
        });

        // Function to get personality page URL and store it
        function storePersonalityUrl(personalityId) {
            // console.log('Storing personality URL for ID:', personalityId);
            
            // Find the personality div by class that includes the ID
            const personalityElement = jQuery('.personalities-quiz__personality.' + personalityId);
            
            if (personalityElement.length) {
                // Get the personality data from data attribute
                let personalityData = personalityElement.data('personality');
                
                // If we have JSON data, use it
                if (personalityData) {
                    let targetUrl = personalityData.url;
                    
                    // Clean the URL if it starts with //
                    if (targetUrl.startsWith('//')) {
                        targetUrl = targetUrl.replace('//', 'http://');
                    }
                    
                    // Get the price range from the form or use stored value
                    const priceRange = getPriceRangeParam();
                    
                    // Add price range parameter if available
                    if (priceRange) {
                        // Check if URL already has parameters
                        targetUrl += (targetUrl.indexOf('?') > -1) ? '&' : '?';
                        targetUrl += 'price_range=' + priceRange;
                    }
                    
                    // Make sure we have a valid URL
                    if (targetUrl && targetUrl.length > 1) {
                        // Store the personality info in sessionStorage
                        sessionStorage.setItem('quiz_winner_url', targetUrl);
                        sessionStorage.setItem('quiz_winner_personality', personalityId);
                        sessionStorage.setItem('quiz_winner_personality_data', JSON.stringify(personalityData));
                        
                        // Also store the price range separately in case we need to recalculate URL later
                        if (priceRange) {
                            sessionStorage.setItem('quiz_price_range', priceRange);
                        }
                        return targetUrl;
                    }
                } else {
                    // Fallback to the old method if data attribute is not available
                    let targetUrl = personalityElement.text().trim();
                    
                    // Clean the URL if it starts with //
                    if (targetUrl.startsWith('//')) {
                        targetUrl = targetUrl.replace('//', 'http://');
                    }
                    
                    // Get the price range from the form or use stored value
                    const priceRange = getPriceRangeParam();
                    
                    // Add price range parameter if available
                    if (priceRange) {
                        // Check if URL already has parameters
                        targetUrl += (targetUrl.indexOf('?') > -1) ? '&' : '?';
                        targetUrl += 'price_range=' + priceRange;
                    }
                    
                    // Make sure we have a valid URL
                    if (targetUrl && targetUrl.length > 1) {
                        // Store the personality URL and ID in sessionStorage
                        sessionStorage.setItem('quiz_winner_url', targetUrl);
                        sessionStorage.setItem('quiz_winner_personality', personalityId);
                        
                        // Also store the price range separately
                        if (priceRange) {
                            sessionStorage.setItem('quiz_price_range', priceRange);
                        }
                        return targetUrl;
                    }
                }
            }
            return false;
        }

        // Calculate winning personality without storing URL (for checking ties)
        function calculateWinnerWithoutSaving() {
            // Find the personality with the highest points
            let maxPoints = 0;
            let winningPersonalities = [];

            for (const personality in personalityPoints) {
                const points = personalityPoints[personality];

                if (points > maxPoints) {
                    maxPoints = points;
                    winningPersonalities = [personality];
                } else if (points === maxPoints) {
                    winningPersonalities.push(personality);
                }
            }

            // Return results without storing anything
            if (winningPersonalities.length === 1) {
                return { winner: winningPersonalities[0], isTie: false };
            } else if (winningPersonalities.length > 1) {
                return { winners: winningPersonalities, isTie: true };
            }
            
            return { winner: null, isTie: false };
        }

        // Calculate winning personality and store URL
        function calculateAndStoreWinner() {
            // Find the personality with the highest points
            let maxPoints = 0;
            let winningPersonalities = [];

            for (const personality in personalityPoints) {
                const points = personalityPoints[personality];

                if (points > maxPoints) {
                    maxPoints = points;
                    winningPersonalities = [personality];
                } else if (points === maxPoints) {
                    winningPersonalities.push(personality);
                }
            }

            // If there's only one winner, store the URL
            if (winningPersonalities.length === 1) {
                storePersonalityUrl(winningPersonalities[0]);
                return { winner: winningPersonalities[0], isTie: false };
            } else if (winningPersonalities.length > 1) {
                return { winners: winningPersonalities, isTie: true };
            }
            
            return { winner: null, isTie: false };
        }

        // Function to check if the form has validation errors
        function hasFormValidationErrors() {
            return form.find('.gfield_validation_message').length > 0 || 
                   form.find('.gform_validation_errors').length > 0;
        }

        // Function to check for confirmation and attempt redirect
        function checkConfirmationAndRedirect() {
            // console.log('Checking for confirmation to redirect...');
            if (jQuery('.gform_confirmation_wrapper').length > 0) {
                // console.log('Confirmation found, attempting redirect');
                
                // Get the winner personality ID
                const personalityId = sessionStorage.getItem('quiz_winner_personality');
                
                // Always regenerate the URL with the latest price range
                if (personalityId) {
                    // console.log('Regenerating URL with latest price range for personality:', personalityId);
                    const redirectUrl = storePersonalityUrl(personalityId);
                    
                    if (redirectUrl) {
                        // console.log('Redirecting to personality page:', redirectUrl);
                        // Clear all session storage
                        // sessionStorage.removeItem('quiz_winner_personality');
                        // sessionStorage.removeItem('quiz_price_range');
                        // // Remove URL last since we're using it for the redirect
                        // sessionStorage.removeItem('quiz_winner_url');
                        // Redirect
                        // window.location.href = redirectUrl;
                        saveQuizData(redirectUrl);
                        return true;
                    }
                } else {
                    // // Fallback to stored URL if no personality ID
                    // const redirectUrl = sessionStorage.getItem('quiz_winner_url');
                    // if (redirectUrl) {
                    //     // console.log('Redirecting to stored URL:', redirectUrl);
                    //     // Clear storage
                    //     // sessionStorage.removeItem('quiz_winner_url');
                    //     // sessionStorage.removeItem('quiz_winner_personality');
                    //     // sessionStorage.removeItem('quiz_price_range');
                    //     // Redirect
                    //     // window.location.href = redirectUrl;
                    //     saveQuizData(redirectUrl);
                    //     return true;
                    // }
                }
            }
            return false;
        }

        // Handle form submission
        if (form.length) {
            // Capture the submit button
            submitButton = form.find('.gform_button')[0];
            
            // Add custom button after the real submit button
            if (submitButton) {
                jQuery(submitButton).after(customSubmitBtn);
                
                // Add click handler to custom button
                customSubmitBtn.on('click', function(e) {
                    e.preventDefault();

                    const totalQuestions = jQuery('.personalities-quiz__question:not(.personalities-quiz__question--last)').length;
                    const regularQuestionsComplete = answeredQuestions.size >= totalQuestions;
                    
                    // Scroll to the top of the quiz section
                    if (!regularQuestionsComplete){
                        jQuery('html, body').animate({
                            scrollTop: jQuery('.personalities-quiz__quiz').offset().top - 50
                        }, 500);
                    }
                    
                    // If we already have a tie and need tiebreaker but haven't answered it yet
                    if (tiebreakerNeeded && selectedTiebreakerPersonality === null) {
                        // Calculate the current result again to get winners
                        const result = calculateWinnerWithoutSaving();
                        if (result.isTie && tiebreakerDialog.length) {
                            // Filter tiebreaker answers to only show those matching tied personalities
                            tiebreakerButtons.each(function() {
                                const personality = jQuery(this).data('personality');
                                if (result.winners.includes(personality.toString())) {
                                    jQuery(this).show();
                                } else {
                                    jQuery(this).hide();
                                }
                            });
                            
                            // Show the tiebreaker dialog
                            tiebreakerDialog[0].showModal();
                        }
                    } else {
                        // Show the message only for regular questions
                        incompleteMessage.show();
                        
                        // Highlight unanswered questions
                        jQuery('.personalities-quiz__question:not(.personalities-quiz__question--last)').each(function(index) {
                            if (!answeredQuestions.has(index)) {
                                jQuery(this).addClass('unanswered-highlight');
                                jQuery('.personalities-quiz__incomplete-message').show();
                                // setTimeout(function() {
                                //     jQuery('.unanswered-highlight').removeClass('unanswered-highlight');
                                // }, 2000);
                            }
                        });
                    }
                });
                
                // Initial button state setup
                updateSubmitButtonState();
            }

            // Intercept the form submission
            form.on('submit', function(e) {
                e.preventDefault(); // Prevent default form submission
                
                // Check if all questions have been answered
                const totalQuestions = jQuery('.personalities-quiz__question:not(.personalities-quiz__question--last)').length;
                if (answeredQuestions.size < totalQuestions) {
                    // Show incomplete message
                    incompleteMessage.show();
                    
                    // Highlight unanswered questions
                    jQuery('.personalities-quiz__question:not(.personalities-quiz__question--last)').each(function(index) {
                        if (!answeredQuestions.has(index)) {
                            jQuery(this).addClass('unanswered-highlight');
                        }
                    });
                    
                    // Scroll to the top of the quiz section
                    jQuery('html, body').animate({
                        scrollTop: jQuery('.personalities-quiz__quiz').offset().top - 50
                    }, 500);
                    
                    return false;
                }
                
                // Calculate the winning personality and check for ties
                const result = calculateWinnerWithoutSaving();
                
                // Check if there's a tie
                if (result.isTie && tiebreakerDialog.length) {
                    // If tiebreaker has not been answered yet
                    if (selectedTiebreakerPersonality === null) {
                        // Set tiebreaker needed flag
                        tiebreakerNeeded = true;
                        
                        // Filter tiebreaker answers to only show those matching tied personalities
                        tiebreakerButtons.each(function() {
                            const personality = jQuery(this).data('personality');
                            if (result.winners.includes(personality.toString())) {
                                jQuery(this).show();
                            } else {
                                jQuery(this).hide();
                            }
                        });
                        
                        // Show the tiebreaker dialog
                        tiebreakerDialog[0].showModal();
                        return false;
                    }
                    
                    // If tiebreaker was already answered, store the selected personality
                    storePersonalityUrl(selectedTiebreakerPersonality);
                }
                else if (!result.isTie && result.winner) {
                    // For single winner, store the URL
                    storePersonalityUrl(result.winner);
                }
                
                // Use AJAX to submit the form
                const formData = new FormData(form[0]);
                
                // Disable form inputs during submission
                form.find('input, button, select, textarea').prop('disabled', true);
                
                // Add loading indicator
                // const loadingIndicator = jQuery('<div class="form-submitting-indicator">Submitting...</div>');
                // form.append(loadingIndicator);
                
                // Make the AJAX request
                jQuery.ajax({
                    url: form.attr('action'),
                    type: 'POST',
                    data: formData,
                    processData: false,
                    contentType: false,
                    success: function(response) {
                        // Check if there's a confirmation message in the response
                        if (response.indexOf('gform_confirmation_wrapper') > -1) {
                            // Get stored redirect URL
                            const redirectUrl = sessionStorage.getItem('quiz_winner_url');
                            
                            if (redirectUrl) {
                                // If we have a URL, save quiz data and redirect
                                saveQuizData(redirectUrl);
                            } else {
                                // If no redirect URL, just show the confirmation
                                form.replaceWith(jQuery(response).find('.gform_confirmation_wrapper'));
                            }
                        } else {
                            // If no confirmation, probably validation errors
                            form.replaceWith(jQuery(response).find('.gform_wrapper'));
                        }
                    },
                    error: function() {
                        // Re-enable form inputs on error
                        form.find('input, button, select, textarea').prop('disabled', false);
                        loadingIndicator.remove();
                        
                        // Show error message
                        form.prepend('<div class="submission-error">There was an error submitting the form. Please try again.</div>');
                    }
                });
                
                return false;
            });

            // Add listeners for Gravity Forms events
            if (typeof window.gform !== 'undefined') {
                // Listen for form render events (happens after validation)
                jQuery(document).on('gform_post_render', function() {
                    // console.log('Form re-rendered after submission attempt');
                    
                    // Check if we have validation errors
                    if (hasFormValidationErrors()) {
                        // console.log('Validation errors found, not redirecting');
                        // Clear any stored URL if there are validation errors
                        sessionStorage.removeItem('quiz_winner_url');
                        sessionStorage.removeItem('quiz_winner_personality');
                    } else {
                        // No validation errors found - recalculate winner and store URL
                        // const result = calculateAndStoreWinner();
                        // console.log('Recalculated winner');
                        // Then check for confirmation
                        // setTimeout(checkConfirmationAndRedirect, 500);
                    }
                });
                
                // Listen for successful form submission
                jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
                    // console.log('Gravity Form confirmation loaded event, form ID:', formId);
                    
                    // Make sure we have calculated the current winner before redirecting
                    if (!sessionStorage.getItem('quiz_winner_url')) {
                        calculateAndStoreWinner();
                        // console.log('Recalculated winner');
                    }
                    
                    // setTimeout(checkConfirmationAndRedirect, 100);
                });
            }

            // Add additional direct listener for AJAX confirmation
            jQuery(document).ajaxSuccess(function(event, xhr, settings) {
                if (settings.url && settings.url.indexOf('gf_ajax_frame') > -1) {
                    // console.log('GF Ajax success detected');
                    
                    // Recalculate winner if needed before redirecting
                    if (!sessionStorage.getItem('quiz_winner_url')) {
                        calculateAndStoreWinner();
                        // console.log('Recalculated winner 672');
                    }
                    
                    // setTimeout(checkConfirmationAndRedirect, 500);
                }
            });

            // Watch for form changes with MutationObserver (as a fallback)
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'childList') {
                        // Check if a confirmation wrapper was added
                        if (jQuery(mutation.target).find('.gform_confirmation_wrapper').length > 0 || 
                            jQuery('.gform_confirmation_wrapper').length > 0) {
                            // console.log('Confirmation detected by MutationObserver');
                            
                            // Make sure we have calculated the current winner before redirecting
                            if (!sessionStorage.getItem('quiz_winner_url')) {
                                calculateAndStoreWinner();
                            }
                            
                            setTimeout(checkConfirmationAndRedirect, 100);
                        }
                    }
                });
            });

            // Start observing the entire document with focus on the quiz form area
            const quizFormContainer = jQuery('.personalities-quiz__question__form');
            if (quizFormContainer.length) {
                observer.observe(quizFormContainer[0], { childList: true, subtree: true });
                observer.observe(document.body, { childList: true, subtree: true });
            }
            
            // Set interval as last resort fallback
            const checkInterval = setInterval(function() {
                if (checkConfirmationAndRedirect()) {
                    clearInterval(checkInterval);
                }
            }, 1000);
            
            // Clean up interval after 10 seconds
            setTimeout(function() {
                clearInterval(checkInterval);
            }, 10000);
        }

        // Add an event listener for when the tiebreaker dialog is closed (either through the X or by clicking outside)
        if (tiebreakerDialog.length) {
            tiebreakerDialog[0].addEventListener('close', function() {
                // If a tiebreaker personality was selected
                if (selectedTiebreakerPersonality) {
                    // console.log('Tiebreaker dialog closed with selection:', selectedTiebreakerPersonality);
                    // Store the URL for the selected personality
                    storePersonalityUrl(selectedTiebreakerPersonality);
                    // Update tiebreaker status
                    tiebreakerNeeded = false;
                    // Update submit button visibility
                    updateSubmitButtonState();
                }
            });
        }
    }
});


function saveQuizData(redirectUrl) {
    const personalityAnswers = [];

    jQuery('.personalities-quiz__question__answer.selected').each(function() {
        const questionText = jQuery(this).closest('.personalities-quiz__question').find('.question-text').text().trim();
        const personality = jQuery(this).data('personality');
        personalityAnswers.push({ question: questionText, personality: personality });
    });

    const winnerPersonality = sessionStorage.getItem('quiz_winner_personality');
    const priceRange = sessionStorage.getItem('quiz_price_range');

    // Grab Gravity Form field values by input ID
    const email       = jQuery(`input[name="${quizFieldIDs.email}"]`).val() || '';
    const zipCode     = jQuery(`input[name="${quizFieldIDs.zipCode}"]`).val() || '';
    const gender      = jQuery(`input[name="${quizFieldIDs.gender}"]:checked`).val() || '';
    const age         = jQuery(`input[name="${quizFieldIDs.age}"]:checked`).val() || '';
    const ticketSpend = jQuery(`input[name="${quizFieldIDs.ticketSpend}"]:checked`).val() || '';
    const consent = jQuery(`input[name^="${quizFieldIDs.consent}"][value="1"]`).is(':checked') ? 1 : 0;
    const firstname   = jQuery(`input[name="${quizFieldIDs.firstname}"]`).val() || '';
    const lastname    = jQuery(`input[name="${quizFieldIDs.lastname}"]`).val() || '';


    jQuery.ajax({
        url: ajax_params.ajax_url,
        type: 'POST',
        data: {
            action: 'store_quiz_data_by_entry',
            personality_answers: JSON.stringify(personalityAnswers),
            winner: winnerPersonality,
            price_range: priceRange,
            email: email,
            zip_code: zipCode,
            gender: gender,
            age: age,
            ticket_spend: ticketSpend,
            consent: consent,
            firstname: firstname,
            lastname: lastname,
        },
        success: function() {
            // Clear session storage AFTER successful data storage
            sessionStorage.removeItem('quiz_winner_personality');
            sessionStorage.removeItem('quiz_price_range');
            sessionStorage.removeItem('quiz_winner_url');

            // Redirect to the result page
            window.location.href = redirectUrl;
        },
        error: function(xhr, status, error) {
            console.error('Error saving quiz data:', error);
            // Redirect anyway to prevent user being stuck
            window.location.href = redirectUrl;
        }
    });
}